const SectionHeader = ({ children }) => {
  return <div className='mb-2 text-2xl'>{children}</div>;
};

export default SectionHeader;
